export var ZHB_STEP_PREFIX = 'zhb-step-list';
export var ZHB_STEP_ITEM_PREFIX = "".concat(ZHB_STEP_PREFIX, "-item");